import * as act from '@/store/settings.temp.actions';

const state = {
  isShowMessages: true,
  isDetailLoggingEnabled: false,
  accessToken: null,
  isSignalRConnected: false,
  unregisteredUserToken: '',
  signLibFilesServerVersion: ''
};

const actions = {};

const mutations = {
  [act.MUT_ISSHOWMSG](state: any, v: boolean): void {
    state.isShowMessages = v;
  },
  [act.MUT_ACCESSTOKEN](state: any, v: string): void {
    state.accessToken = v;
  },
  [act.MUT_SIGNALRCONNECTED](state: any, v: string): void {
    state.isSignalRConnected = v;
  },
  [act.MUT_UNREGUSERTOKEN](state: any, v: string): void {
    state.unregisteredUserToken = v;
  },
  [act.MUT_SIGNLIBFILESSERVERVERSION](state: any, version: string): void {
    state.signLibFilesServerVersion = version;
  }
};

const getters = {
  [act.GET_ISSHOWMSG]: state => {
    return state.isShowMessages;
  },
  [act.GET_ACCESSTOKEN]: state => {
    return state.accessToken;
  },
  [act.GET_SIGNALRCONNECTED]: state => {
    return state.isSignalRConnected;
  },
  [act.GET_UNREGUSERTOKEN]: state => {
    return state.unregisteredUserToken;
  },
  [act.GET_SIGNLIBFILESSERVERVERSION]: (state: any) => state.signLibFilesServerVersion
};

export const settingsTemp = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
